/**
 * BaseError
 */

export class BaseError extends Error {
  constructor(
    public errorMessage: string[],
    public show: boolean,
  ) {
    super();
  }
}

/**
 * processError
 */

export const processError = (e: unknown, defaultMessage: string): string[] => {
  if (typeof e === 'string') {
    console.log(e);
    return [defaultMessage];
  }
  else if (e instanceof BaseError) {
    const baseError = e as BaseError;
    return baseError.show ? baseError.errorMessage : [defaultMessage];
  }
  else if (e instanceof Error) {
    console.log(e);
    return [defaultMessage];
  }
  return [defaultMessage];
}

/**
 * isBaseError
 */

export const isBaseError = (err: any): boolean => {
  return "message" in err && "show" in err;
}

/**
 * toBaseError
 */

export const toBaseError = (err: any): BaseError => {
  return new BaseError(err.message, err.show);
}

/**
 * UserFriendlyError
 * Gera um erro que sera exibido ao usuário.
 */

export class UserFriendlyError extends BaseError {
  constructor(
    message: string | string[],
  ) {
    if (typeof message === 'string') {
      super([message], true);
    } else if (typeof message === 'object' && message instanceof Array) {
      super(message, true);
    } else {
      super(['Erro inesperado!'], false);
    }
  }
}